import { render } from "./investmentAccount.vue?vue&type=template&id=22e030f7&scoped=true"
import script from "./investmentAccount.vue?vue&type=script&lang=js"
export * from "./investmentAccount.vue?vue&type=script&lang=js"

import "./investmentAccount.vue?vue&type=style&index=0&id=22e030f7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e030f7"]])

export default __exports__